"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var renameIds = function (svg, id) {
    return ((svg === null || svg === void 0 ? void 0 : svg.length) > 0
        ? svg
            .replace(/<g clip-path="url\(#(.+?)\)"/gim, "<g clip-path=\"url(#" + id + "_$1)\"")
            .replace(/<clipPath id="(.+?)"/gim, "<clipPath id=\"" + id + "_$1\"")
        : svg);
};
exports.default = renameIds;
